<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{ $t('nBox.editNBox') }}</strong>
        </b-card-header>
        <b-card-body>
            <loader v-if="isLoading" :loader="isLoading"></loader>
            <c-form
                v-else
                :data="form"
                :isEditing="true"
                @cancel="goBack"
                @submit="onSubmit"
            ></c-form>
        </b-card-body>
    </b-card>
</template>

<script>
import CForm from '../components/form'
import i18n from '@/i18n'
import { updateNBox } from './api'
import { getNBoxByIdFromAPI } from '../api'
import { mapperFormToApi, mapperApiToForm } from '../mappers'
import Loader from '@/views/components/loader'
import notification, { success, danger } from '@/lib/notification'

notification.init()

export default {
    name: 'Edit',
    components: {
        CForm,
        Loader,
    },
    data() {
        return {
            form: null,
            nBoxId: null,
            isLoading: true,
        }
    },
    mounted() {
        this.onMounted()
    },
    methods: {
        onMounted() {
            this.isLoading = true
            this.nBoxId = this.$route.params.id
            this.getNBox()
                .then(this.setFormData)
                .finally(() => {
                    this.isLoading = false
                })
        },
        getNBox() {
            return getNBoxByIdFromAPI(this.nBoxId, {
                with:
                    'variables;quadrants;periods;status;teams;occupationGroups',
            }).then(resp => resp.data.data)
        },
        setFormData(rawData) {
            this.form = mapperApiToForm(rawData)
        },
        onSubmit(form, setLoader) {
            setLoader(true)
            updateNBox(this.nBoxId, mapperFormToApi(form))
                .then(() => {
                    this.notificationNBoxEditedSuccessfully()
                    this.goBack()
                })
                .catch(() => {
                    this.notificationError()
                })
                .finally(() => {
                    setLoader(false)
                })
        },
        goBack() {
            this.$router.back()
        },
        notificationNBoxEditedSuccessfully() {
            success(
                i18n.t('notification.editedSuccessfully', {
                    item: 'N-Box',
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
